import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "../Dashboard";
import { toast } from "sonner";
import { btn, btnGhost, card, errMsg, field, Provenance } from "./ui";

const EMPTY = { title: "", company: "", location: "", status: "active", description: "", linked_deal_id: "" };

export default function StaffingJobs() {
    const [rows, setRows] = useState([]);
    const [q, setQ] = useState("");
    const [status, setStatus] = useState("");
    const [form, setForm] = useState(EMPTY);
    const [busy, setBusy] = useState(false);

    const load = () => {
        const params = {};
        if (q.trim()) params.q = q.trim();
        if (status) params.status = status;
        return api.get("/ats-core/jobs", { params }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
    };
    useEffect(() => { load(); }, []); // eslint-disable-line

    const create = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/ats-core/jobs", { ...form, linked_deal_id: form.linked_deal_id || null });
            setForm(EMPTY);
            toast.success("Job opgeslagen");
            await load();
        } catch (err) {
            toast.error(errMsg(err));
        } finally {
            setBusy(false);
        }
    };

    const confirm = async (id) => {
        try {
            await api.post(`/ats-core/jobs/${id}/confirm`);
            toast.success("Job bevestigd — nu actief");
            await load();
        } catch (err) {
            toast.error(errMsg(err));
        }
    };

    const close = async (id) => {
        try {
            await api.post(`/ats-core/jobs/${id}/close`);
            await load();
        } catch (err) {
            toast.error(errMsg(err));
        }
    };

    return (
        <PageHeader title="Jobs" subtitle="Draft blijft draft tot een mens bevestigt. Daarna pas een actieve pipeline-job.">
            <form onSubmit={create} className={`${card} grid md:grid-cols-3 gap-3 mb-6`} data-testid="job-form">
                <input className={field} required placeholder="Titel" value={form.title} data-testid="job-title"
                    onChange={(e) => setForm({ ...form, title: e.target.value })} />
                <input className={field} placeholder="Bedrijf" value={form.company} data-testid="job-company"
                    onChange={(e) => setForm({ ...form, company: e.target.value })} />
                <input className={field} placeholder="Locatie" value={form.location}
                    onChange={(e) => setForm({ ...form, location: e.target.value })} />
                <select className={field} value={form.status} data-testid="job-status"
                    onChange={(e) => setForm({ ...form, status: e.target.value })}>
                    <option value="draft">draft</option>
                    <option value="active">active</option>
                    <option value="closed">closed</option>
                </select>
                <input className={field} placeholder="Deal-id (optioneel)" value={form.linked_deal_id}
                    onChange={(e) => setForm({ ...form, linked_deal_id: e.target.value })} />
                <textarea className={`${field} md:col-span-3`} rows={2} placeholder="Beschrijving" value={form.description}
                    onChange={(e) => setForm({ ...form, description: e.target.value })} />
                <button className={btn} disabled={busy} data-testid="job-save">Job aanmaken</button>
            </form>

            <div className="flex gap-2 mb-4">
                <input className={`${field} max-w-xs`} placeholder="Zoek titel of bedrijf" value={q}
                    data-testid="job-search" onChange={(e) => setQ(e.target.value)} />
                <select className={`${field} max-w-[160px]`} value={status} onChange={(e) => setStatus(e.target.value)}>
                    <option value="">Alle</option>
                    {["draft", "active", "closed"].map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <button className={btnGhost} onClick={load} data-testid="job-filter">Filter</button>
            </div>

            <div className="space-y-2" data-testid="job-list">
                {rows.map((j) => (
                    <div key={j.id} className={`${card} flex flex-wrap items-center gap-3`} data-testid={`job-row-${j.id}`}>
                        <div className="flex-1 min-w-[200px]">
                            <div className="text-white">{j.title}</div>
                            <div className="text-xs text-[var(--jr-text-2)]">{j.company || "—"} · {j.location || "—"}</div>
                        </div>
                        <span className="text-xs font-mono uppercase" data-testid={`job-status-${j.id}`}>{j.status}</span>
                        <Provenance row={j} />
                        {j.status === "draft" && (
                            <button className={btn} data-testid={`job-confirm-${j.id}`} onClick={() => confirm(j.id)}>Bevestigen</button>
                        )}
                        {j.status === "active" && (
                            <button className={btnGhost} onClick={() => close(j.id)}>Sluiten</button>
                        )}
                    </div>
                ))}
                {!rows.length && <p className="text-sm text-[var(--jr-text-3)]">Geen jobs.</p>}
            </div>
        </PageHeader>
    );
}
